import API from 'js/lib/api';

export default API('/api/courseraPlusUpgrades.v2', {
  type: 'rest',
});
